import React, {useState, useEffect, useRef, useMemo} from "react";
import {Container, Card, Form} from "react-bootstrap";
// import "./VendorAssignment.css";
import "./ReportSection.css";
import axios from "../../util/Axios/AxiosInstance";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as ReactBootStrap from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {addDays, addMonths, addYears, format} from "date-fns";
import {DateRangePicker} from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendarDays} from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import filterFactory, {textFilter, Comparator } from "react-bootstrap-table2-filter";

const SKELETON_ROW_COUNT = 8;

const createSkeletonRows = (isDepartment = false) =>
    Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => ({
        id: `skeleton-${index}`,
        sNo: index + 1,
        employeeCode: <Skeleton />,
        employeeName: <Skeleton />,
        departmentName: <Skeleton />,
        deviceLocationIn: <Skeleton />,
        deviceLocationOut: <Skeleton />,
        ...(isDepartment ? {gateCheckIn: <Skeleton />, gateCheckOut: <Skeleton />} : {}),
        shiftBand: <Skeleton />,
        shiftStart: <Skeleton />,
        shiftEnd: <Skeleton />,
        durationHhmmss: <Skeleton />,
    }));

function DeviceAttendance({reportType = "Gate", title = "Gate Attendance", exportFileName = "GateAttendance"}) {
    const isDepartment = reportType === "Department";
    const [tableData, setTableData] = useState(() => createSkeletonRows(isDepartment));
    let [formatDate, setFormatDate] = useState('');
    const date = format(new Date(), 'yyyy-MM-dd');
    let [selectedDate, setSelectedDate] = useState(date);
    const [loading, setLoading] = useState(true);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [branchCode, setBranchCode] = useState(
        localStorage.getItem("branchId")
    );
    const [employeeIdSearch, setEmployeeIdSearch] = useState("");

    const [open, setOpen] = useState(false);
    const pickerRef = useRef(null);
    const divRef = useRef(null);
    const abortControllerRef = useRef(null);
    const [range, setRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);

    useEffect(() => {
        AOS.init();
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date();
        setFormatDate(months[date.getMonth()] + date.getDate() + ',' + date.getFullYear());
    }, []);

    useEffect(() => {
        if (!open) {
            return;
        }
        const handleClickOutside = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [open]);

    useEffect(() => {
        if (open) {
            return;
        }
        setEmployeeIdSearch("");
        getAttendanceReports(range);
    }, [open, range, reportType]);

    useEffect(() => {
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, []);

    const getAttendanceReports = (range) => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        const controller = new AbortController();
        abortControllerRef.current = controller;
        setLoading(true);
        setTableData(createSkeletonRows(isDepartment));

        const startDate = format(range[0].startDate, "yyyy-MM-dd");
        const endDate = format(range[0].endDate, "yyyy-MM-dd");
      const postObj = {
        fromDate: startDate,
        toDate: endDate,
        plantCode: localStorage.getItem("plantCode"),
        reportType: reportType
      };

      axios.post("vms/facialLogs", postObj, { signal: controller.signal })
          .then((response)=> {
              const payload = response?.data;
              if (!payload || payload.status === "failed") {
                  setTableData([]);
                  setLoading(false);
                  return;
              }

              const records = Array.isArray(payload.data) ? payload.data : [];
              setTableData(
                  records
                      .filter(Boolean)
                      .map((record, index) => ({
                          ...record,
                          id: `${record.employeeCode ?? "row"}-${record.shiftStart ?? index}-${index}`,
                          sNo: index + 1,
                      }))
              );
              setLoading(false);
          })
          .catch((e)=> {
              if (e.code === "ERR_CANCELED") {
                  return;
              }
              console.error(e);
              setTableData([]);
              setLoading(false);
          })

    }

    const filteredTableData = useMemo(() => {
        const search = employeeIdSearch.trim().toLowerCase();
        if (!search || loading) {
            return tableData;
        }
        return tableData.filter((row) => {
            const code = row?.employeeCode;
            if (code == null || typeof code === "object") {
                return false;
            }
            return String(code).toLowerCase().includes(search);
        });
    }, [tableData, employeeIdSearch, loading]);

    const formatDateTime = (cell) => {
        if (!cell || typeof cell !== "string") {
            return "";
        }
        return cell.replace("T", " ");
    };

    const formatDateTimeShort = (cell) => {
        const full = formatDateTime(cell);
        if (!full) {
            return "";
        }
        const [datePart, timePart = ""] = full.split(" ");
        const dateSegments = datePart.split("-");
        if (dateSegments.length === 3) {
            const [year, month, day] = dateSegments;
            const [hour = "00", minute = "00"] = timePart.split(":");
            return `${day}/${month}/${year} ${hour}:${minute}`;
        }
        return full;
    };

    const dateTimeFormatter = (cell) => (
        <span title={formatDateTime(cell)}>{formatDateTimeShort(cell)}</span>
    );

    const textCellFormatter = (cell) => (
        <span title={cell ?? ""}>{cell ?? ""}</span>
    );

    const colStyle = (minWidth) => ({
        minWidth,
        style: {minWidth},
    });

    const headerStyle = (minWidth) => ({
        width: minWidth,
        minWidth,
        textAlign: "left",
    });

    const dateTimeCsvFormatter = (cell) => formatDateTimeShort(cell) || formatDateTime(cell) || "";

    const withDateExport = (column) => ({
        ...column,
        csvFormatter: dateTimeCsvFormatter,
    });

    const deviceInColumn = {
        dataField: "deviceLocationIn",
        text: "Device In",
        sort: true,
        filter: textFilter(),
        formatter: textCellFormatter,
        headerStyle: () => headerStyle("100px"),
        style: () => colStyle("100px"),
    };

    const deviceOutColumn = {
        dataField: "deviceLocationOut",
        text: "Device Out",
        sort: true,
        filter: textFilter(),
        formatter: textCellFormatter,
        headerStyle: () => headerStyle("100px"),
        style: () => colStyle("100px"),
    };

    const checkInColumn = withDateExport({
        dataField: "shiftStart",
        text: isDepartment ? "Dept In" : "Check In",
        sort: true,
        filter: textFilter(),
        formatter: dateTimeFormatter,
        headerStyle: () => headerStyle("145px"),
        style: () => colStyle("145px"),
    });

    const checkOutColumn = withDateExport({
        dataField: "shiftEnd",
        text: isDepartment ? "Dept Out" : "Check Out",
        sort: true,
        filter: textFilter(),
        formatter: dateTimeFormatter,
        headerStyle: () => headerStyle("145px"),
        style: () => colStyle("145px"),
    });

    const gateColumns = isDepartment ? [
        withDateExport({
            dataField: "gateCheckIn",
            text: "Gate In",
            sort: true,
            filter: textFilter(),
            formatter: dateTimeFormatter,
            headerStyle: () => headerStyle("145px"),
            style: () => colStyle("145px"),
        }),
        withDateExport({
            dataField: "gateCheckOut",
            text: "Gate Out",
            sort: true,
            filter: textFilter(),
            formatter: dateTimeFormatter,
            headerStyle: () => headerStyle("145px"),
            style: () => colStyle("145px"),
        }),
    ] : [];

    const logTimeColumns = isDepartment
        ? [...gateColumns, checkInColumn, deviceInColumn, checkOutColumn, deviceOutColumn]
        : [checkInColumn, deviceInColumn, checkOutColumn, deviceOutColumn];

    const columns = [
        {
            dataField: "sNo",
            text: "S No.",
            formatter: (cell, row, rowIndex) => {
                return (pageNumber - 1) * pageSize + (rowIndex + 1);
            },
            csvFormatter: (cell) => cell ?? "",
            headerStyle: () => headerStyle("55px"),
            style: () => ({...colStyle("55px"), textAlign: "center"}),
        },
        {
            dataField: "employeeCode",
            text: "Emp Code",
            sort: true,
            filter: textFilter(),
            formatter: textCellFormatter,
            headerStyle: () => headerStyle("95px"),
            style: () => colStyle("95px"),
        },
        {
            dataField: "employeeName",
            text: "Emp Name",
            sort: true,
            filter: textFilter(),
            formatter: textCellFormatter,
            headerStyle: () => headerStyle("130px"),
            style: () => colStyle("130px"),
        },
        {
            dataField: "departmentName",
            text: "Department",
            sort: true,
            filter: textFilter(),
            formatter: textCellFormatter,
            headerStyle: () => headerStyle("120px"),
            style: () => colStyle("120px"),
        },
        {
            dataField: "shiftBand",
            text: "Shift",
            sort: true,
            filter: textFilter(),
            formatter: textCellFormatter,
            headerStyle: () => headerStyle("60px"),
            style: () => colStyle("60px"),
        },
        ...logTimeColumns,
        {
            dataField: "durationHhmmss",
            text: "Duration",
            sort: true,
            filter: textFilter(Comparator.GT),
            formatter: textCellFormatter,
            headerStyle: () => headerStyle("90px"),
            style: () => colStyle("90px"),
        },
    ];

    const paginationOptions = {
        sizePerPage: pageSize,
        onSizePerPageChange: (sizePerPage) => {
            setPageSize(sizePerPage);
        },
        onPageChange: (page) => {
            setPageNumber(page);
        },
    };

    const escapeCsvValue = (value) => {
        const str = value == null ? "" : String(value);
        if (/[",\n]/.test(str)) {
            return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
    };

    const getExportCellValue = (row, column, rowIndex) => {
        if (column.dataField === "sNo") {
            return rowIndex + 1;
        }
        const raw = row[column.dataField];
        if (column.csvFormatter) {
            return column.csvFormatter(raw, row, rowIndex);
        }
        if (raw == null || typeof raw === "object") {
            return "";
        }
        return raw;
    };

    const exportToCsv = () => {
        if (!filteredTableData.length) {
            return;
        }

        const headerRow = columns.map((column) => escapeCsvValue(column.text)).join(",");
        const dataRows = filteredTableData.map((row, rowIndex) =>
            columns
                .map((column) => escapeCsvValue(getExportCellValue(row, column, rowIndex)))
                .join(",")
        );

        const csvContent = [headerRow, ...dataRows].join("\n");
        const blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${exportFileName} ${formatDate}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
    };

    const MyExportCSV = () => (
        <div className="exportButton">
            <button className="btn btn-success" onClick={exportToCsv}>
                Export to CSV !!
            </button>
        </div>
    );

    const dateFilteredData = (item) => {
        setRange([item.selection]);
    };

    return (
        <Card className="cardStyl">
            <Container fluid className="px-0">
                <div className={"mt-2"}>
                    {/*<h2>Laborer Master</h2>*/}
                    <h5 className={"priColor d-flex align-items-center gap-2"}>
                        {title}
                        {loading && (
                            <ReactBootStrap.Spinner animation="border" size="sm" role="status">
                                <span className="sr-only">Loading...</span>
                            </ReactBootStrap.Spinner>
                        )}
                    </h5>
                </div>
                <div>
                    <div className={"row"}>
                        <div style={{marginBottom: "10px"}}>
                            {/*<button className={"btn btn-primary"} variant="primary"*/}
                            {/*        style={{ float: "left" }}*/}
                            {/*        >*/}
                            {/*    Filter*/}
                            {/*</button>*/}
                            {/* <button className={"btn btn-primary"} variant="primary"
                                style={{ float: "right" }}
                                onClick={(e)=> HandleEvent(7.1)}>
                            Add New
                        </button> */}
                        </div>
                    </div>
                    <div></div>
                    {/*<div className="subDiv">*/}
                    {/*    <div className={"inputImage"}>*/}
                    {/*        <input type={'date'} value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)}/>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div ref={pickerRef}>
                    <div className="subDiv attendance-filters">
                        <div className={"inputImage"}>
                            <input
                                value={`${format(range[0].startDate, "dd/MM/yyyy")} - ${format(
                                    range[0].endDate,
                                    "dd/MM/yyyy"
                                )}`}
                                className="inputElement"
                                readOnly
                                onClick={() => setOpen((open) => !open)}
                            />
                            <FontAwesomeIcon
                                icon={faCalendarDays}
                                className="Calendericon"
                                onClick={() => setOpen((open) => !open)}
                            />
                        </div>
                        <div className="employee-search-wrap">
                            <Form.Control
                                type="text"
                                placeholder="Search by Emp Code"
                                value={employeeIdSearch}
                                onChange={(e) => {
                                    setEmployeeIdSearch(e.target.value);
                                    setPageNumber(1);
                                }}
                                className="inputElement employee-search-input"
                                disabled={loading}
                            />
                        </div>
                    </div>
                        {open && (
                            <div className={"daterangepickerdiv"}>
                                <DateRangePicker
                                    onChange={(item) => dateFilteredData(item)}
                                    editableDateInputs={true}
                                    showSelectionPreview={true}
                                    moveRangeOnFirstSelection={false}
                                    months={2}
                                    ranges={range}
                                    direction="horizontal"
                                />
                            </div>
                        )}
                    </div>
                    <div>
                        <ToolkitProvider
                            key={reportType}
                            keyField="id"
                            data={filteredTableData}
                            columns={columns}
                        >
                            {(props) => (
                                <React.Fragment>
                                    {!loading && filteredTableData.length > 0 ? <MyExportCSV /> : ""}
                                    <div
                                         data-aos="zoom-in-right"
                                         data-aos-duration="550"
                                         ref={divRef}
                                         className={`attendance-table-scroll ${isDepartment ? "attendance-table-scroll--department" : ""}`}
                                         style={{
                                             // maxHeight: "480px",
                                             opacity: loading ? 0.7 : 1,
                                         }}
                                    >
                                        <BootstrapTable
                                            bootstrap4
                                            noDataIndication={
                                                loading
                                                    ? "Loading attendance data..."
                                                    : employeeIdSearch.trim()
                                                        ? "No records found for this Emp Code"
                                                        : "No data available"
                                            }
                                            pagination={paginationFactory(paginationOptions)}
                                            wrapperClasses={`table-responsive attendance-report-table ${isDepartment ? "attendance-report-table--department" : ""}`}
                                            {...props.baseProps}
                                            data={filteredTableData}
                                            filter={filterFactory()}
                                        />
                                    </div>
                                </React.Fragment>
                            )}
                        </ToolkitProvider>
                    </div>
                </div>
            </Container>
        </Card>
    );
}

export default DeviceAttendance;
